/* src/app/components/discovery/dialogs/shared-production-downloads/shared-production-download-settings.component.scss */
mat-dialog-content {
  display: flex;
  flex-direction: column;
}
mat-form-field[appearance=outline] {
  --outlined-text-field-outline-color: #a8a8a8;
}
:host-context(.dark-theme) mat-form-field[appearance=outline] {
  --outlined-text-field-outline-color: rgba(255, 255, 255, 0.4);
}
mat-form-field.custom-label-float-above-position {
  --top: 22px;
}
.icon {
  font-size: 20px;
  color: #3f51b5;
}
.disabled {
  color: rgba(0, 0, 0, 0.12) !important;
  cursor: default;
}
button {
  cursor: pointer;
  display: flex;
  background: none;
  border: none;
  align-content: center;
  justify-content: center;
  align-items: center;
}
div.custom-scroll {
  padding: 5px 3px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}
.download-link-container {
  display: flex;
  align-items: center;
  border-radius: 20px;
  padding: 8px;
  height: 36px;
  border: 1px solid rgba(168, 168, 197, 0.95);
  background-color: rgba(235, 235, 235, 0.94);
}
.custom-scroll::-webkit-scrollbar {
  height: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background-color: rgb(36, 62, 144);
  border-radius: 3px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: rgb(36, 62, 144);
}
.custom-scroll::-webkit-scrollbar-corner {
  background: rgba(0, 0, 0, 0.1);
}
::ng-deep ngx-skeleton-loader .loader {
  min-height: 36px;
  border-radius: 20px;
}
:host-context(.dark-theme) ::ng-deep ngx-skeleton-loader .loader {
  background-color: #414141;
  min-height: 36px;
  border-radius: 20px;
}
:host-context(.dark-theme) .disabled {
  color: rgba(255, 255, 255, 0.3) !important;
  cursor: default;
}
:host-context(.dark-theme) .icon {
  font-size: 20px;
  color: #FFC107;
}
:host-context(.dark-theme) .download-link-container {
  border: 1px solid rgba(122, 122, 122, 0.9490196078);
  background-color: rgba(73, 73, 73, 0.768627451);
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar {
  height: 6px;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar-thumb {
  background-color: #ffc107;
  border-radius: 3px;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #f3be1f;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar-corner {
  background: #000;
}
/*# sourceMappingURL=shared-production-download-settings.component.css.map */
